export default {
  article_details: "Artikeldetails",
  asset_details: "Assetdetails",
  asset_list: "Asset List",
  assign_amount: "Betrag zuordnen ",
  attributeSets: "Attribute Sets",
  detailView: "Detailansicht",
  new_customer_request: "Neue Kundenanfrage",
  request_details: "Anfragedetails",
  generalInfo: "General Information",
  currentMetrics: "Current metrics",
  technicalData: "Technische Daten",
  fcsSetup: "Asset Hierarchy/Commissioning",
  systemInfo: "System Informationen",
  assignedTo: "Assigned to",
  recentActivity: "Letzte Aktivität",
  fleetInfo: "Informationen zu Einsatzgruppen",
  backendServiceOverview: "Backend-Dienste Übersicht",
};
